import { EFinancingProgram } from '@if/core/types'
import AsyncActionButton from '@src/components/AsyncActionButton'
import { ApplicantDto } from '@src/types/CreditApplicationSchema'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

interface Props {
  id: string
  financingProgramId: EFinancingProgram
  coapp: ApplicantDto | null
  isHardDecline?: boolean
}
const AddChangeCoappButton = ({ id, financingProgramId, coapp, isHardDecline = false }: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const coAppButtonText = coapp ? t('viewCreditApplication.changeCoapp') : t('viewCreditApplication.addCoapp')
  return (
    <AsyncActionButton
      sx={{ mb: 1 }}
      fullWidth
      variant="contained"
      disabled={isHardDecline}
      onClick={() => {
        navigate(`/credits/${financingProgramId}/${id}/edit?showTabIndex=1&addCoApp=true`)
      }}
    >
      {coAppButtonText}
    </AsyncActionButton>
  )
}

export default AddChangeCoappButton
